import { useAccount } from 'wagmi';
import Text from '../../atoms/Text';
import Button from '../../molecules/Button';

interface IWatchlistWarningProps {
  absolute?: boolean;
  width: string;
  text: string;
  buttonText: string;
  onSubmit: () => void;
}

const WatchlistWarning = ({
  absolute,
  width,
  text,
  buttonText,
  onSubmit,
}: IWatchlistWarningProps) => {
  const { address } = useAccount();

  return (
    <div
      className='watchlist__warning'
      style={{
        position: absolute ? 'absolute' : 'static',
        marginTop: absolute ? 0 : 8,
        width,
      }}
    >
      <Text size={12} className='text--weight-500 text--orange-200'>
        {text}
      </Text>
      <div className='watchlist__warning__btn'>
        <Button
          size='s'
          action={onSubmit}
          text={address ? buttonText : 'Connect wallet'}
          variant='ghost'
        />
      </div>
    </div>
  );
};

export default WatchlistWarning;
